import { Analytics } from '@plaudit/analytics';

export default class FeaturedProjects {
	private analytics = Analytics.getInstance();
	private wrapperEl: HTMLElement = document.getElementById('featuredProjects');
	private triggerEl: NodeListOf<Element> = document.querySelectorAll('.featuredProjects__nav a');
	private buttonEl: NodeListOf<Element> = document.querySelectorAll('.featuredProjects a.btn');
	private targetEl: NodeListOf<Element> = document.querySelectorAll('.featuredProject');
	private triggerCount: number = this.triggerEl.length;
	private autoAdvance: {
		active: boolean,
		timerId?: number,
		delay: number,
		index: number
	} = {
			active: false,
			delay: 6500,
			index: 0
		};
	private activateByIndex(index: number): void {
		this.showTarget(index);
		this.markTrigger(index);
	}
	private autoAdvanceToNext = () => {
		this.autoAdvance.index =
			(this.autoAdvance.index !== 0)
				? this.autoAdvance.index - 1
				: this.triggerCount - 1;
		this.activateByIndex(this.autoAdvance.index);
	}
	private buildEventHandlers(): void {
		for (let i: number = 0, l: number = this.triggerEl.length; i < l; i++) {
			const element: Element = this.triggerEl[i];
			this.triggerEl[i].addEventListener('click', this.handleTriggerClick);
		}
		for (let i: number = 0, l: number = this.buttonEl.length; i < l; i++) {
			const element: Element = this.buttonEl[i];
			this.buttonEl[i].addEventListener('click', this.handleButtonClick);
		}
	}
	private handleButtonClick = (event: Event) => {
		const element = <HTMLElement>event.currentTarget;
		this.analytics.trackEvent('Featured Project', 'View Project', element.getAttribute('data-title'));
	}
	private handleTriggerClick = (event: Event) => {
		event.preventDefault();
		const element = <HTMLElement>event.currentTarget;

		clearInterval(this.autoAdvance.timerId);
		for (let i = 0; i < this.triggerEl.length; i++) {
			if (this.triggerEl[i] === element) {
				this.analytics.trackEvent('Featured Project', 'Click', 'Item: '+(this.triggerEl.length - i));
				this.activateByIndex(i);
				return;
			}
		}
	}
	private hideTargets(): void {
		for (let i: number = 0, l: number = this.targetEl.length; i < l; i++) {
			this.targetEl[i].classList.remove('target');
		}
	}
	private showTarget(index: number): void {
		const targetEl: Element = this.targetEl[index];
		const isActive: boolean = targetEl.classList.contains('target');

		this.hideTargets();
		targetEl.classList.add('target');
	}
	private markTrigger(index: number): void {
		for (let i: number = 0, l: number = this.triggerEl.length; i < l; i++) {
			const element: Element = this.triggerEl[i];

			if (i === index) {
				element.classList.add('target');
			} else {
				element.classList.remove('target');
			}
		}
	}
	private setupAutoAdvance(): void {
		this.autoAdvance.active = true;
		this.autoAdvance.timerId = window.setInterval(this.autoAdvanceToNext, this.autoAdvance.delay);
	}

	constructor() {
		if (!this.wrapperEl) {
			return;
		}
		this.buildEventHandlers();
		this.activateByIndex(this.triggerCount - 1);
		this.setupAutoAdvance();
	}
}
